import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Opens the item named in the URL (e.g. `?playlistId=…`) once its list has
 * loaded, then drops the param so closing the item doesn't reopen it.
 * Unknown ids (deleted, other organisation) are dropped without opening.
 */
export function useDeepLinkParam<T extends { id: string }>(
  name: string,
  items: readonly T[] | undefined,
  open: (item: T) => void,
): void {
  const [params, setParams] = useSearchParams();
  const id = params.get(name);

  useEffect(() => {
    if (!id || !items) return;
    const item = items.find((candidate) => candidate.id === id);
    if (item) open(item);
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(name);
        return next;
      },
      { replace: true },
    );
  }, [id, items, name, open, setParams]);
}
